import React, { useEffect, useRef, useState } from "react";
import "./PostModal.css";
import toast from "react-hot-toast";
import axios from "axios";
import { base_url } from "../App";

const PostModal = ({ isOpen, onClose, setNewPostData }) => {
  const [fetchUrl, setFetchUrl] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const base64String = await handleImageToBase64(file);
      setImage(base64String);
    } else {
      console.error("No file selected");
    }
  };

  const handleImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async () => {
    if (!title && !description && !image) {
      toast.error("Please add data to create a post.", {
        position: "top-center",
      });
      return;
    }
    const type = `${title ? "title" : ""}${
      image ? (title || image ? "_" : "") + "image" : ""
    }${description ? (image ? "_" : "") + "desc" : ""}`;

    axios
      .post(
        `${base_url}posts/`,
        {
          title: title,
          description: description,
          image: image,
          type: type,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        }
      )
      .then((response) => {
        setNewPostData(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to submit the post.", {
          position: "top-center",
        });
      });

    onClose();
    setTitle("");
    setDescription("");
    setImage(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFetch = () => {
    axios
      .post(`${base_url}fetch-meta-data/`, { url: fetchUrl })
      .then((response) => {
        setTitle(response.data.data.title);
        setDescription(response.data.data.description);
        setImage(response.data.data.image);
        toast.success(response.data.message);
      });
  };

  return (
    <>
      <div
        className={`modal-overlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
      ></div>
      <div
        className={`h-[80dvh] overflow-auto no-scrollbar modal ${
          isOpen ? "open" : ""
        }`}
      >
        <div className="modal-content">
          <h2 className="my-3">
            Paste post link to fetch title, description & image
          </h2>
          <input
            type="text"
            placeholder="Fetch Post"
            onChange={(e) => setFetchUrl(e.target.value)}
          />
          <div className="modal-actions">
            <button onClick={handleFetch} className="button">
              Fetch
            </button>
          </div>
          <div className="relative py-5">
            <hr />
            <p className="bg-white absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 p-2 rounded-full shadow-lg size-10">
              or
            </p>
          </div>

          <h2 className="my-3">Create New Post</h2>
          <input
            type="text"
            placeholder="Enter title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <textarea
            placeholder="Enter description"
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            ref={fileInputRef}
            onChange={handleImageChange}
          />

          {image && (
            <img
              src={image}
              alt=""
              className="w-[95%] h-56 mx-auto rounded-2xl"
            />
          )}

          <div className="modal-actions">
            <button onClick={handleSubmit} className="button">
              Submit
            </button>
            <button onClick={onClose} className="button">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostModal;
